/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Link from 'next/link';
import styles from '@features/navigation/components/MegaMenuDesktop/MegaMenuDesktop.styles';
import { BehaviourType, ICategory, TCategoriesTree } from '@features/categories';
import useCategoryArray from '@hooks/useCategoryArray';
import Button from '@components/Button/Button';
import MenuLabels from '@components/MenuLabels/MenuLabels';
import { NAVIGATION_NAME_MAX_COUNT } from '@features/navigation/const';
type PropsType = {
  marketingList: TCategoriesTree;
  onSelectType: (product: ICategory | null) => void;
  onClose?: () => void | null;
};
const MarketingProductsType = ({
  marketingList,
  onSelectType,
  onClose = undefined
}: PropsType) => {
  const marketingProducts = useCategoryArray(marketingList);
  const category: Array<ICategory> = marketingProducts.filter((item: ICategory) => item.behaviour !== BehaviourType.COLLECTION);
  const collection: Array<ICategory> = marketingProducts.filter((item: ICategory) => item.behaviour === BehaviourType.COLLECTION);
  const isTooLong = (name: string): boolean => name.length > NAVIGATION_NAME_MAX_COUNT;
  const renderItems = (items: Array<ICategory>) => items.map(item => {
    const haveLabel = item.is_new || item.personalization || item.promo;
    const handleClick = () => onSelectType(item);
    if (item?.behaviour === 'hidden') return null;
    if (item?.behaviour === 'external_link') {
      if (!item?.external_link?.length) return null;
      return <li key={item.id} sx={styles.marketingProductsItem(false, haveLabel)}>
            <Link href={item.external_link} onClick={onClose}>
              <span>
                <span className={`menu-product-item-${item.id} menu-product-item`}>
                  {isTooLong(item.name) ? item.name.split(' ').map(word => <span key={word}>{word}&nbsp;</span>) : <span>{item.name} </span>}
                </span>
              </span>
            </Link>
            {haveLabel && <MenuLabels isNew={item.is_new} isPersonalization={item.personalization} isPromo={item.promo} />}
          </li>;
    }
    return <li key={item.id} onClick={handleClick} sx={styles.marketingProductsItem(isTooLong(item.name), haveLabel)}>
          <Button variant="link" variantColor="dark" cy={`MarketingProductsType-${item.slug}`} addClassName="nav_menu-lvl-two">
            <span className={`menu-product-item-${item.id} menu-product-item`}>
              {isTooLong(item.name) ? item.name.split(' ').map(word => <span key={word}>{word}&nbsp;</span>) : <span>{item.name} </span>}
            </span>
          </Button>
          {haveLabel && <MenuLabels isNew={item.is_new} isPersonalization={item.personalization} isPromo={item.promo} />}
        </li>;
  });
  return <>
      {collection.length > 0 && <ul key={Math.random()} sx={styles.marketingProductsType}>
          {renderItems(collection)}
        </ul>}
      {category.length > 0 && <ul key={Math.random()} sx={collection.length > 0 ? styles.marketingProductsTypeCollection : styles.marketingProductsType}>
          {renderItems(category)}
        </ul>}
    </>;
};
export default MarketingProductsType;